/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_Payouts_Are_ProcesseInputs */

const en_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate payouts are processed on the 1st of each month via Stripe. Minimum payout threshold is $50 USD.`)
};

const es_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pagos de afiliados se procesan el día 1 de cada mes a través de Stripe. El umbral mínimo de pago es de $50 USD.`)
};

const fr_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les paiements d'affiliation sont traités le 1er de chaque mois via Stripe. Le seuil de paiement minimum est de 50 USD.`)
};

const de_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate-Auszahlungen werden am 1. jedes Monats über Stripe verarbeitet. Die Mindestauszahlungsgrenze beträgt 50 USD.`)
};

const ja_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイトの支払いは毎月1日にStripe経由で処理されます。最低支払額は50米ドルです。`)
};

const zh_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广佣金将在每月的 1 号通过 Stripe 进行结算。最低提现门槛为 50 美元。`)
};

const ar_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتم معالجة مدفوعات التسويق بالعمولة في اليوم الأول من كل شهر عبر Stripe. الحد الأدنى للدفع هو 50 دولاراً أمريكياً.`)
};

const id_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran afiliasi diproses pada tanggal 1 setiap bulannya melalui Stripe. Ambang batas pembayaran minimum adalah $50 USD.`)
};

const it_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I pagamenti agli affiliati vengono elaborati il 1° di ogni mese tramite Stripe. La soglia minima di pagamento è di 50 USD.`)
};

const ru_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнерские выплаты обрабатываются 1-го числа каждого месяца через Stripe. Минимальный порог выплаты составляет $50 USD.`)
};

const pt_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pagamentos de afiliados são processados no 1º dia de cada mês via Stripe. O limite mínimo de pagamento é de $50 USD.`)
};

const ko_affiliate_payouts_are_processe = /** @type {(inputs: Affiliate_Payouts_Are_ProcesseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트 수익금은 매월 1일 Stripe를 통해 처리됩니다. 최소 지급 한도는 50달러(USD)입니다.`)
};

/**
* | output |
* | --- |
* | "Affiliate payouts are processed on the 1st of each month via Stripe. Minimum payout threshold is $50 USD." |
*
* @param {Affiliate_Payouts_Are_ProcesseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_payouts_are_processe = /** @type {((inputs?: Affiliate_Payouts_Are_ProcesseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_Payouts_Are_ProcesseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_payouts_are_processe(inputs)
	if (locale === "es") return es_affiliate_payouts_are_processe(inputs)
	if (locale === "fr") return fr_affiliate_payouts_are_processe(inputs)
	if (locale === "de") return de_affiliate_payouts_are_processe(inputs)
	if (locale === "ja") return ja_affiliate_payouts_are_processe(inputs)
	if (locale === "zh") return zh_affiliate_payouts_are_processe(inputs)
	if (locale === "ar") return ar_affiliate_payouts_are_processe(inputs)
	if (locale === "id") return id_affiliate_payouts_are_processe(inputs)
	if (locale === "it") return it_affiliate_payouts_are_processe(inputs)
	if (locale === "ru") return ru_affiliate_payouts_are_processe(inputs)
	if (locale === "pt") return pt_affiliate_payouts_are_processe(inputs)
	return ko_affiliate_payouts_are_processe(inputs)
});